import BaseAPI from './base';

class GoalService extends BaseAPI {
  getSupportersByGoalId = async (goalId) => {
    const url = `/Goals/${goalId}/publicSupporters?page=0&pageSize=1000`;

    return this.getJson(url);
  };
}

export default new GoalService();
